Module('paginas.landing-page-2-cols', function(Page) {
  'use strict';

  Page.fn.initialize = function() {
  };
});
